<div class="banner">
  <!-- [style.background-image]="'url(' + src + ')'"> -->

  <!-- <img class="banner-img"
    [ngSrc]="src" 
    fill 
    placeholder
    priority> -->

  <!-- <advanced-image 
    class="banner-image"
    [cldImg]="cloudImg"
    fill 
    placeholder
    priority
    ></advanced-image> -->

  <!-- <advanced-image [cldImg]="cloudImg" 
    [plugins]="this.plugins"
    class="banner-image">
  </advanced-image> -->

  <!-- https://cloudinary.com/documentation/responsive_html -->
  <img
    *ngIf="src"
    class="banner-image"
    sizes="(min-width: 50em) 50em, 100vw"
    [srcset]="srcset"
    [src]="src"
    alt="Responsive image" 
    fetchpriority="high" />


  <div class="banner-content-wrapper">
    <div class="banner-content">
      <ng-content></ng-content>
    </div>
  </div>
  

  <div *ngIf="!hideShroud"
    class="banner-shroud"></div>
</div>